import { ref } from 'vue'
import type { Ref } from 'vue'
import type { BreadcrumbItem } from '@nuxt/ui'
import { useMenuBreadcrumbStore } from '../stores/useMenuBreadcrumbStore'
import type { MenuBreadcrumb } from '../entities/MenuBreadcrumb'
import { useHeadSchemaComposable } from '~~/modules/head/composables/useHeadSchemaComposable'
import type { HeadListItem } from '~~/modules/head/entities/HeadListItem'

export function useMenuBreadcrumb() {
  const breadCrumbMenuStore = useMenuBreadcrumbStore()

  const MenuBreadcrumbInstance: MenuBreadcrumb =
    breadCrumbMenuStore.getMenuBreadcrumb

  const items: Ref<BreadcrumbItem[]> = ref([])

  MenuBreadcrumbInstance.forEach(item => {
    const breadCrumbItem: BreadcrumbItem = {
      label: item.name,
      href: item.selected ? '' : item.href,
    }

    items.value.push(breadCrumbItem)
  })

  const schemaItems: HeadListItem[] = []

  MenuBreadcrumbInstance.forEach((item, index) => {
    const breadCrumbItem: HeadListItem = {
      position: (index + 1) as HeadListItem['position'],
      name: item.name,
      url: routes().addDomain({ slug: item.href }),
    }

    schemaItems.push(breadCrumbItem)
  })

  const { breadcrumbSchema } = useHeadSchemaComposable()
  breadcrumbSchema(schemaItems)

  return { items }
}
